module.exports = __webpack_public_path__ + "img/near.75073082.svg";